export default "__VITE_ASSET__BLPRBwN2__"